import { gql } from '@apollo/client';
const pageDataFields = `
id
name
preparedPageBuilderComponents
canonicalUrl
category {
  id
  name
}
tags {
  id
  name
}
slug
image{
  id
  data
  url
}
formattedMetaTitle
formattedMetaDescription
__typename
cacheControlMaxAge`;
const checkUrlQuery = gql`
  query checkUrl($url: String!) {
    checkUrl(url: $url) {
      itemId
      itemEntity
      urlTo,
      pageData: record {
        ...on ContentContentInterface {
          ${pageDataFields}
        }
      }
    }
  }
`;
const getPageQuery = ({
  actions: {
    get,
    getPublished
  } = {},
  isPreview
}) => {
  const getMethod = !isPreview && getPublished ? getPublished : get;
  return gql`
    query pageData($id: String!) {
      pageData: ${getMethod}(id: $id) {
        ${pageDataFields}
        url
      }
    }
  `;
};
const GET_ENTITY_SCHEMA = gql`
  query getEntitySchema($id: String!) {
    entitySchema: getEntitySchema(id: $id) {
      id
      identifier
      actions
    }
  }
`;
export { checkUrlQuery, getPageQuery, GET_ENTITY_SCHEMA };
//# sourceMappingURL=index.js.map